
import * as Tone from "tone"

export type InstrumentName = 'marimba'
export const notes = ["D3", "F3", "G3", "A3", "C4", "D4"]

const INSTRUMENT_MAPPING = {
    'marimba': {
        'A#2': 'As2.wav',
        'A#3': 'As3.wav',
        'A#4': 'As4.wav',
        'A#5': 'As5.wav',
        'A#6': 'As6.wav',
        'A2': 'A2.wav',
        'A3': 'A3.wav',
        'A4': 'A4.wav',
        'A5': 'A5.wav',
        'A6': 'A6.wav',
        'B2': 'B2.wav',
        'B3': 'B3.wav',
        'B4': 'B4.wav',
        'B5': 'B5.wav',
        'B6': 'B6.wav',
        'C#2': 'Cs2.wav',
        'C#3': 'Cs3.wav',
        'C#4': 'Cs4.wav',
        'C#5': 'Cs5.wav',
        'C#6': 'Cs6.wav',
        'C2': 'C2.wav',
        'C3': 'C3.wav',
        'C4': 'C4.wav',
        'C5': 'C5.wav',
        'C6': 'C6.wav',
        'D#2': 'Ds2.wav',
        'D#3': 'Ds3.wav',
        'D#4': 'Ds4.wav',
        'D#5': 'Ds5.wav',
        'D#6': 'Ds6.wav',
        'D2': 'D2.wav',
        'D3': 'D3.wav',
        'D4': 'D4.wav',
        'D5': 'D5.wav',
        'D6': 'D6.wav',
        'E2': 'E2.wav',
        'E3': 'E3.wav',
        'E4': 'E4.wav',
        'E5': 'E5.wav',
        'E6': 'E6.wav',
        'F#2': 'Fs2.wav',
        'F#3': 'Fs3.wav',
        'F#4': 'Fs4.wav',
        'F#5': 'Fs5.wav',
        'F#6': 'Fs6.wav',
        'F2': 'F2.wav',
        'F3': 'F3.wav',
        'F4': 'F4.wav',
        'F5': 'F5.wav',
        'F6': 'F6.wav',
        'G#2': 'Gs2.wav',
        'G#3': 'Gs3.wav',
        'G#4': 'Gs4.wav',
        'G#5': 'Gs5.wav',
        'G#6': 'Gs6.wav',
        'G2': 'G2.wav',
        'G3': 'G3.wav',
        'G4': 'G4.wav',
        'G5': 'G5.wav',
        'G6': 'G6.wav',
    }
}

const loadSample = async function (name: InstrumentName, instrumentOptions: Partial<Tone.SamplerOptions>) {
    const sampler = new Promise<Tone.Sampler>((resolve, reject) => {
        const instrumentMapping = INSTRUMENT_MAPPING[name]

        const cleanedMapping = Object.entries(instrumentMapping).reduce((prev, [key, value]) => {
            if (notes.includes(key)) prev[key] = value

            return prev
        }, {} as Record<string, string>)

        const samplerInstance = new Tone.Sampler({
            urls: cleanedMapping,
            baseUrl: `${name}/`,
            ...instrumentOptions,
            onload: () => {
                if (instrumentOptions.onload != null) instrumentOptions.onload()
                console.log('Loaded ' + name)

                resolve(samplerInstance)
            },
            onerror: (err) => {
                console.error('error loading', err)
                reject(err)
            },
        })
    })
    return await sampler
}


let loop: Tone.Part | null = null
let instrument: Tone.Sampler | null = null

let initialized = false

export async function initEngine() {
    await Tone.start()
    Tone.getTransport().start()

    instrument = await loadSample('marimba', {})

    const gain = new Tone.Gain(2).toDestination()
    const reverb = new Tone.Reverb(1.3).connect(gain)
    instrument.connect(reverb)

    // loop = new Tone.Part(
    //     (time, note) => {
    //         if (note == null) return
    //         // Log(`Time: ${time.toFixed(2)}, Note: ${JSON.stringify(note)}`, friendSynth)

    //         const play = (note: string) => {
    //             if (instrument == null) return
    //             instrument.triggerAttackRelease(note, '1n', time)
    //         }

    //         if (Array.isArray(note)) {
    //             note.forEach((n) => {
    //                 play(n)
    //             })

    //         } else {
    //             play(note)
    //         }
    //     },
    //     [
    //         ["0:0:0", ["D4"]],
    //         ["0:1:2", ["C4"]],
    //         ["0:3:0", ["A3"]],
    //         ["1:1:0", ["A4"]],
    //         ["1:3:0", ["F3"]],
    //     ]
    // )

    // loop.loop = true
    // loop.loopEnd = "2:0:2"

    Tone.getTransport().bpm.value = 80

    initialized = true
}

export function triggerSound(note: string): void {
    if (!initialized || !instrument) return

    instrument.triggerAttackRelease(note, '1n')
}


export function startEngine(): void {
    if (loop != null) loop.start(0)
}

export function stopEngine(): void {
    if (loop != null) loop.stop()
}